<table red-table table [attr.fontSize]="fontSize" [ngClass]="{'margin-bottom':marginButton}"
                 [attr.minSize]="minSize" 
                 [attr.theme]="theme"
                 [style]="minWidthValue ? 'min-width:'+minWidthValue : ''">
    <ng-content></ng-content>
</table>

